import {ComponentStore} from '@ngrx/component-store';
import {List} from 'immutable';
import {Filtro} from '~model/filtro/filtros/filtro';
import {FiltroVoid} from '~model/filtro/filtros/filtro-void';
import {FiltroFactory} from '~model/filtro/filtro-factory';
import {EventEmitter, Injectable} from '@angular/core';
import {RotaVo} from '~model/vo/rota-vo';

export interface ToolbarFiltroItemState {
  comparadores: List<string>;
  filtro: Filtro<RotaVo>;
}

@Injectable()
export class ToolbarFiltroItemStore extends ComponentStore<ToolbarFiltroItemState> {

  private objChange = new EventEmitter();

  constructor() {
    super({
      comparadores: List<string>([]),
      filtro: new FiltroVoid(),
    });
  }

  inicializarFiltro(nome: string): void {
    this.setState(state => ({...state, filtro: FiltroFactory.build(nome, this.comparadores)}));
  }

  updateFiltro(): void {
    this.setState((state) => ({
      ...state,
      filtro: FiltroFactory.build(state.filtro.getFiltroNome(), this.comparadores),
    }));
  }

  saveComparador(comparador: string): void {
    if (comparador) {
      this.setState(state => ({...state, comparadores: state.comparadores.concat(comparador)}));
    }
    this.updateFiltro();
    this.emitEvent();
  }

  deleteComparador(index: number): void {
    this.setState(state => ({...state, comparadores: state.comparadores.delete(index)}));

    this.updateFiltro();
    this.emitEvent();
  }

  // Reseta o valor selecionado sem destruir/recriar o componente (evita "piscar" a UI)
  resetFiltro(): void {
    this.setState(state => ({...state, comparadores: List<string>([])}));
    this.updateFiltro();
  }

  get comparadores(): string[] {
    return this.get().comparadores.toArray();
  }

  onObjChange(eventEmitter: EventEmitter<Filtro<RotaVo>>): void {
    this.objChange = eventEmitter;
  }

  private emitEvent(): void {
    this.objChange.emit(this.get().filtro);
  }

  getState(): ToolbarFiltroItemState {
    return this.get();
  }

}
